export default "__VITE_ASSET__DHU4OL6U__"